import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-id"]
const _hoisted_2 = { class: "form__set" }
const _hoisted_3 = { class: "form__row" }
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Email", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["id", "name"]
const _hoisted_8 = { class: "form__row" }
const _hoisted_9 = ["for"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "First name", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["id", "name"]
const _hoisted_13 = { class: "form__row" }
const _hoisted_14 = ["for"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Second name", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["id", "name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_re_captcha_submit = _resolveComponent("re-captcha-submit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      class: "js-cm-form",
      id: _ctx.formId,
      action: "https://www.createsend.com/t/subscribeerror?description=",
      method: "post",
      "data-id": _ctx.dataId
    }, [
      _createElementVNode("fieldset", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: _ctx.emailId,
            class: "form__label form__required"
          }, _hoisted_6, 8, _hoisted_4),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
            type: "email",
            required: "",
            autocomplete: "Email",
            "aria-label": "Email",
            class: "form__input js-cm-email-input qa-input-email",
            id: _ctx.emailId,
            maxlength: "200",
            name: _ctx.emailName
          }, null, 8, _hoisted_7), [
            [_vModelText, _ctx.formData.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", {
            for: _ctx.firstId,
            class: "form__label form__required"
          }, _hoisted_11, 8, _hoisted_9),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.firstName) = $event)),
            type: "text",
            required: "",
            autocomplete: "off",
            class: "form__input",
            "aria-label": "First name",
            id: _ctx.firstId,
            maxlength: "200",
            name: _ctx.firstName
          }, null, 8, _hoisted_12), [
            [_vModelText, _ctx.formData.firstName]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", {
            for: _ctx.lastId,
            class: "form__label form__required"
          }, _hoisted_16, 8, _hoisted_14),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.secondName) = $event)),
            type: "text",
            autocomplete: "off",
            class: "form__input",
            "aria-label": "Last name",
            id: _ctx.lastId,
            maxlength: "200",
            name: _ctx.lastName
          }, null, 8, _hoisted_17), [
            [_vModelText, _ctx.formData.secondName]
          ])
        ])
      ]),
      _createVNode(_component_re_captcha_submit, {
        "is-filled": _ctx.allData,
        "site-key": _ctx.captchaKey,
        "site-name": _ctx.siteName,
        label: _ctx.label
      }, null, 8, ["is-filled", "site-key", "site-name", "label"])
    ], 8, _hoisted_1)
  ]))
}